import { Component, HostListener, input, Input, ViewChild } from '@angular/core';
import { IConfig } from '@shared/interfaces';
import { environment } from '@env/environment';
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-slide-generator',
  templateUrl: './slide-generator.component.html',
  styleUrl: './slide-generator.component.scss',
})
export class SlideGeneratorComponent {
  imagePerSlide = 4;
  @Input() imagePaths: string[] = [];
  target = '';
  showSideBtn = false;
  showDots = false;
  @Input() isLoading = false;
  @Input({ required: true })
  config!: IConfig;
  responsive: any;
  grid_style: any;
  environment;
  constructor() {
    this.environment = environment;
  }
  ngOnInit() {
    this.showDots = this.config.dots || this.showDots;
    this.showSideBtn = this.config.indicator || this.showSideBtn;
    this.target = this.config.target || this.target;
    this.updatePerSlide();
  }
  getSlids() {
    const perSlideimage = this.imagePerSlide;
    const slide = [];
    let i = 0;
    while (i < this.imagePaths.length) {
      slide.push(this.imagePaths.slice(i, i + perSlideimage));
      i += perSlideimage;
    }
    return slide;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.updatePerSlide();
  }

  updatePerSlide() {
    let itemPerslide: any;
    for (const i in this.config.responsive) {
      if (parseInt(i) <= window.innerWidth) {
        itemPerslide = this.config.responsive[i];
      }
    }

    this.imagePerSlide = itemPerslide.items || this.imagePerSlide;
    this.responsive = itemPerslide;
    this.getSlids();
  }
  trackByFn(index: number, item: any): number {
    return index;
  }

  @ViewChild(NgbCarousel) carousel: NgbCarousel | undefined;
  touchStart: number = 0;
  onTouchStart(event: TouchEvent) {
    this.touchStart = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    const touchEnd = event.changedTouches[0].screenX;
    if (this.touchStart < touchEnd && Math.abs(this.touchStart - touchEnd) >= 50) {
      this.carousel?.prev();
    } else if (this.touchStart > touchEnd && this.touchStart - touchEnd >= 50) {
      this.carousel?.next();
    }
  }
}
